import {useTranslation} from 'react-i18next';

import {Button} from 'components';
import {TRANSLATION_KEYS} from 'locale';
import {WizardFooterProps} from 'types';

const T_KEYS_COMMON = TRANSLATION_KEYS.COMMON;

export const WizardFooter: React.FC<WizardFooterProps> = ({
    hasNext, disabledNext, handleNext, hasPrevious, disabledPrevious, handlePrevious, children
}) => {
    const {t} = useTranslation();
    return (
        <div className='tw-mt-10 tw-flex -sm:tw-flex-col -sm:tw-items-end tw-justify-end tw-items-center tw-flex-wrap'>
            <div className='-md:tw-pb-4 md:tw-mr-4'>{children}</div>

            <div className='tw-flex'>
                {hasPrevious &&
                    <Button
                        icon='chevron-left'
                        width='small'
                        disabled={disabledPrevious}
                        onClick={handlePrevious}
                    >
                        {t(T_KEYS_COMMON.BUTTONS.BACK)}
                    </Button>}

                {hasNext &&
                    <Button
                        icon='chevron-right'
                        className='tw-ml-2'
                        width='small'
                        disabled={disabledNext}
                        color='primary'
                        onClick={handleNext}
                    >
                        {t(T_KEYS_COMMON.BUTTONS.NEXT)}
                    </Button>}
            </div>
        </div>
    );
};